import { render, staticRenderFns } from "./PackageInstance.vue?vue&type=template&id=4acc8536&scoped=true&"
import script from "./PackageInstance.vue?vue&type=script&lang=js&"
export * from "./PackageInstance.vue?vue&type=script&lang=js&"
import style0 from "./PackageInstance.vue?vue&type=style&index=0&id=4acc8536&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acc8536",
  null
  
)

export default component.exports